import TranscriptHandoffLeftIcon from '@/assets/icons/TranscriptHandoffLeftIcon';
import TranscriptHandoffRightIcon from '@/assets/icons/TranscriptHandoffRightIcon';
import { Stack, Typography } from '@mui/material';

export default function TranscriptHandoffRow({ agentName }: { agentName: string }) {
  return (
    <Stack direction='row' alignItems='center' spacing={2} mt={1} justifyContent='center'>
      <TranscriptHandoffLeftIcon />
      <Typography color='primary.main' fontSize={13} fontWeight={500}>
        Conversation handoff to {agentName}{' '}
      </Typography>
      <TranscriptHandoffRightIcon />
    </Stack>
  );
}
